// Base
import { BaseApi } from 'api/base.api'

// Interface
import {
  IAssessmentGeneralProofApi,
  IAssessmentGeneralProofApiRequest,
  IAssessmentGeneralProofApiGetListAttrs,
  IAssessmentGeneralProofApiListResponse,
  IAssessmentGeneralProofApiDownloadDocumentAttrs,
  IAssessmentGeneralProofApiDownloadDocumentResponse,
} from 'interfaces/back-office/assessment/registration/general-proof/general-proof-api.interface'

// Constant
import { ApiConstantHc, ApiConstantHcBase } from 'constant'

// Utils
import { axios_renderHcUrl } from 'utils'

export class AssessmentGeneralProofApi extends BaseApi<IAssessmentGeneralProofApi> implements IAssessmentGeneralProofApiRequest {
  readonly url = ApiConstantHc.ASSESSMENT_REGISTRATION_GENERAL_PROOF_URL
  private assessmentRegistrationGeneralProofUrl = axios_renderHcUrl(this.url, ApiConstantHcBase.ASSESSMENT)

  /**
   * @description Get assessment general proof list
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IAssessmentGeneralProofApiGetListAttrs} payload
   *
   * @return {Promise<IAssessmentGeneralProofApiListResponse>} Promise<IAssessmentGeneralProofApiListResponse>
   */
  async assessmentGeneralProof_getList(
    payload: IAssessmentGeneralProofApiGetListAttrs,
  ): Promise<IAssessmentGeneralProofApiListResponse> {
    return this.POST(
      `${this.assessmentRegistrationGeneralProofUrl}/list/${payload.params.assessmentId}`,
      {},
      { ...payload.requestConfig },
    )
  }

  /**
   * @description Download assessment general proof document
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IAssessmentGeneralProofApiDownloadDocumentAttrs} payload
   *
   * @return {Promise<IAssessmentGeneralProofApiDownloadDocumentResponse>} Promise<IAssessmentGeneralProofApiDownloadDocumentResponse>
   */
  async assessmentGeneralProof_downloadDocument(
    payload: IAssessmentGeneralProofApiDownloadDocumentAttrs,
  ): Promise<IAssessmentGeneralProofApiDownloadDocumentResponse> {
    return this.POST(
      `${this.assessmentRegistrationGeneralProofUrl}/download/${payload.params.blobId}`,
      {},
      { ...payload.requestConfig, responseType: 'blob' },
    )
  }
}
